module.exports = __webpack_public_path__ + "static/media/8-exonumia.2e46b7d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/8-exonumia.mp3
// module id = n422
// module chunks = 0